module.exports = __webpack_public_path__ + "img/renzheng.ac46cde4.jpg";